import { createAction } from '@reduxjs/toolkit';
import { MultiCurrencyAmount } from '@mews-distributor/common';
import { OrderedProduct } from '../views/confirmation/data/types';
import { PurchaseEventReservation } from './integrationsMiddleware/purchaseEvent/types';

const prefix = (actionName: string) => `GA4/${actionName}`;

export const VOUCHER_CODE_SUBMITTED = prefix('VOUCHER_CODE_SUBMITTED');
export const CATEGORIES_LOADED = prefix('CATEGORIES_LOADED');
export const PROPERTIES_LOADED = prefix('PROPERTIES_LOADED');
export const RATES_LOADED = prefix('RATES_LOADED');
export const PRODUCTS_LOADED = prefix('PRODUCTS_LOADED');
export const PROMOTED_SERVICES_LOADED = prefix('PROMOTED_SERVICES_LOADED');
export const SUMMARY_LOADED = prefix('SUMMARY_LOADED');
export const DETAILS_LOADED = prefix('DETAILS_LOADED');
export const CALENDAR_LOADED = prefix('CALENDAR_LOADED');
export const PRICING_WITH_OCCUPANCY_FETCHED = prefix('PRICING_WITH_OCCUPANCY_FETCHED');
export const FLEXIBLE_RATES_FILTER_CHANGED = prefix('FLEXIBLE_RATES_FILTER_CHANGED');

interface ConfirmationLoadedReservation extends PurchaseEventReservation {
    confirmationNumber: string;
    currency: string;
    grossValue: number;
}

interface ConfirmationLoadedPayload {
    reservationGroupId: string;
    reservationGroupName: string;
    reservations: ConfirmationLoadedReservation[];
    orderedProducts: OrderedProduct[];
    totalAmount: MultiCurrencyAmount | null;
    isBookingConfirmedOrPaid: boolean;
    reservationOwnerEmail?: string | null;
}

export const confirmationLoaded = createAction<ConfirmationLoadedPayload>(prefix('CONFIRMATION_LOADED'));
